"use client";

import React from "react";
import { MapPin, Phone, Mail, Clock, Navigation } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function FindOurClinic() {
  const operatingHours = [{
    day: "Monday",
    time: "8:00 AM – 5:00 PM"
  }, {
    day: "Tuesday",
    time: "8:00 AM – 5:00 PM"
  }, {
    day: "Wednesday",
    time: "8:00 AM – 5:00 PM"
  }, {
    day: "Thursday",
    time: "8:00 AM – 5:00 PM"
  }, {
    day: "Friday",
    time: "8:00 AM – 5:00 PM"
  }, {
    day: "Saturday",
    time: "Closed"
  }, {
    day: "Sunday",
    time: "Closed"
  }];
  const mapQuery = encodeURIComponent("4202 Peck Rd, El Monte, CA 91732");
  const mapEmbedUrl = `https://maps.google.com/maps?q=${mapQuery}&t=&z=15&ie=UTF8&iwloc=&output=embed`;
  const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${mapQuery}`;
  return <section data-section-id="85272" id="visit-our-el-monte-clinic" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center lg:text-left">
          <h2 className="text-foreground font-serif text-3xl font-bold tracking-tight sm:text-4xl md:text-5xl">
            Visit Our El Monte Clinic
          </h2>
          <p className="text-muted-foreground font-sans mt-4 max-w-2xl text-lg">
            Experience affordable, high-quality dental care right here in El Monte. Our modern facility is designed for your comfort and efficiency.
          </p>
        </div>

        <div className="flex flex-col gap-8 lg:flex-row lg:items-stretch">
          {}
          <div className="w-full lg:w-2/5">
            <Card className="bg-secondary text-secondary-foreground flex h-full flex-col border-none shadow-xl rounded-2xl">
              <CardHeader className="pb-4">
                <CardTitle className="text-2xl font-serif font-semibold">Clinic Information</CardTitle>
              </CardHeader>
              <CardContent className="flex flex-1 flex-col gap-8">
                <div className="flex flex-col gap-6">
                  <div className="flex items-start gap-4">
                    <div className="bg-primary/10 text-primary mt-1 flex h-10 w-10 shrink-0 items-center justify-center rounded-full">
                      <MapPin className="h-5 w-5" />
                    </div>
                    <div>
                      <h4 className="font-sans font-medium">Our Location</h4>
                      <p className="text-secondary-foreground/80 font-sans mt-1 leading-relaxed">
                        <Link to={directionsUrl} newTab className="hover:text-primary transition-colors">
                          4202 Peck Rd<br />El Monte, CA 91732
                        </Link>
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="bg-primary/10 text-primary mt-1 flex h-10 w-10 shrink-0 items-center justify-center rounded-full">
                      <Phone className="h-5 w-5" />
                    </div>
                    <div>
                      <h4 className="font-sans font-medium">Direct Line</h4>
                      <Link to="tel:+16264445555" className="text-secondary-foreground/80 hover:text-primary mt-1 block transition-colors font-sans">626-268-5990</Link>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="bg-primary/10 text-primary mt-1 flex h-10 w-10 shrink-0 items-center justify-center rounded-full">
                      <Mail className="h-5 w-5" />
                    </div>
                    <div>
                      <h4 className="font-sans font-medium">Email Us</h4>
                      <Link to="mailto:info@smartchoicedentures.com" className="text-secondary-foreground/80 hover:text-primary mt-1 block transition-colors font-sans">smartchoicedentures@gmail.com</Link>
                    </div>
                  </div>
                </div>

                <div className="mt-auto pt-6">
                  <div className="mb-4 flex items-center gap-2">
                    <Clock className="text-primary h-5 w-5" />
                    <h4 className="font-sans font-medium">By Appointment Only. Please call.</h4>
                  </div>
                  <div className="bg-primary/5 rounded-xl p-1">
                    <Table>
                      <TableBody>
                        {operatingHours.map((schedule, i) => <TableRow key={i} data-index={i} className="border-secondary-foreground/10 hover:bg-primary/5 border-b last:border-0">
                            <TableCell className="text-secondary-foreground py-2 font-medium font-sans">
                              {schedule.day}
                            </TableCell>
                            <TableCell className="text-secondary-foreground/80 py-2 text-right font-sans">
                              {schedule.time}
                            </TableCell>
                          </TableRow>)}
                      </TableBody>
                    </Table>
                  </div>
                </div>

                <Button asChild className="mt-4 w-full rounded-full bg-primary text-primary-foreground hover:bg-primary/90 shadow-md transition-all hover:scale-[1.02]" size="lg">
                  <Link to={directionsUrl} newTab>
                    <Navigation className="mr-2 h-4 w-4" />
                    Get Directions
                  </Link>
                </Button>
              </CardContent>
            </Card>
          </div>

          {}
          <div className="ring-border w-full overflow-hidden rounded-2xl shadow-xl ring-1 lg:w-3/5">
            <div className="bg-muted relative h-[400px] w-full lg:h-full">
              <iframe title="Smart Choice Dentures & Implants Location" src={mapEmbedUrl} className="absolute inset-0 h-full w-full border-0 grayscale-[0.2] contrast-[1.1]" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}